import axios from 'axios'; import { axiosPath } from '../../routing/helpers/router';
import { captureAxiosError } from '@/minions/error';

export const FETCH_AUTH_USER = 'FETCH_AUTH_USER';
export const SET_AUTH_USER_SETTINGS = 'SET_AUTH_USER_SETTINGS';
export const SET_AUTH_USER_SIDEBAR = 'SET_AUTH_USER_SIDEBAR';
export const RESET_AUTH_USER = 'RESET_AUTH_USER';
export const SET_AUTH_USER_AVATAR = 'SET_AUTH_USER_AVATAR';

export const fetchAuthUser = () => async (dispatch) => {
  try {
    const response = await axios.post(axiosPath('api_r_user_authUser_getAuthUser'));
    const res = await response.data;
    if (!res.error) dispatch({ type: FETCH_AUTH_USER, payload: res });
  } catch (err) {
      captureAxiosError(err);
  }
};

export const setAuthSettingsLayout = (req) => async (dispatch) => {
  try {
    await axios.post(axiosPath('api_r_user_authUser_setSidebar'), req);
    dispatch(fetchAuthUser());
  } catch (err) {
      captureAxiosError(err);
  }
};
